import t, { docUrlWrapper } from '@zenlayer/zen-intl18';
export const Docs = () => {
  return (
    <div>
      <a
        href={docUrlWrapper('https://docs.console.zenlayer.com/partnerx-docs')}
        target="_blank"
        rel="noreferrer"
      >
        {t('8zJmPZpQ0jf2')}
      </a>
    </div>
  );
};
